import type {Messages} from "../catalogue.en";
// Repeatable title-sheet facts and document reconciliation.
export const patientTitleSheet: Partial<Messages> = {
  "patient.death.mergeMismatch": "В карточках различаются даты смерти. Сначала уточните их на титульных листах, затем повторите объединение.",
  "patient.death.label": "Пациент умер",
  "patient.death.date": "Дата смерти",
  "patient.death.edit": "Указать или исправить сведения о смерти",
  "patient.death.readOnly": "Пациент умер. Добавление и изменение приёмов, протоколов и диагнозов недоступно.",
  "patient.death.dateRequired": "Укажите дату смерти.",
  "patient.death.reason": "Причина исправления",
  "patient.death.reasonRequired": "Укажите причину исправления сведений о смерти.",
  "patient.death.invalid": "Проверьте дату смерти и укажите причину исправления.",
  "patient.death.unsaved": "Несохранённые изменения сведений о смерти пациента",
  "patient.death.age": "Возраст на дату смерти",

  "patient.facts.address.useManual": "Ввести вручную вместо выбора из справочника",
  "patient.facts.address.manualWarning": "Ручной адрес — не пригоден для автоматического обмена адресными данными.",
  "patient.facts.address.registryMethod": "Адрес выбран из справочника",

  "patient.facts.addresses": "Адреса",
  "patient.facts.edit.addresses": "Изменить адреса",
  "patient.facts.history.addresses": "История адресов",
  "patient.facts.address.text": "Полный адрес в исходной записи",
  "patient.facts.address.components": "Состав адреса",
  "patient.facts.address.componentsHint": "Необязательно. Заполните применимые части адреса; полная запись выше должна им соответствовать.",
  "patient.facts.address.registryText": "Полный адрес по справочнику",
  "patient.facts.address.gar": "Выбрать из ГАР",
  "patient.facts.address.garLoading": "Загрузка адресов…",
  "patient.facts.address.garUnavailable": "Адресный справочник недоступен. Можно продолжить ввод адреса вручную.",
  "patient.facts.address.garQuery": "Город, улица или номер",
  "patient.facts.address.garSearch": "Найти адрес",
  "patient.facts.address.garReset": "Искать по всем адресам",
  "patient.facts.address.garFailure": "Не удалось загрузить адрес. Введённые данные сохранены; повторите поиск.",
  "patient.facts.address.garEmpty": "Адреса не найдены.",
  "patient.facts.address.garChildren": "Выбрать улицу, дом или квартиру в этом адресе",
  "patient.facts.address.garSelect": "Использовать этот адрес",
  "patient.facts.address.garStale": "Выбранный адрес больше недоступен в справочнике. Выберите его заново; введённые данные сохранены.",
  "patient.facts.address.region": "Регион / область / штат",
  "patient.facts.address.district": "Район / территория",
  "patient.facts.address.locality": "Город / населённый пункт",
  "patient.facts.address.localityType": "Тип населённого пункта",
  "patient.facts.address.street": "Улица",
  "patient.facts.address.house": "Номер / название дома",
  "patient.facts.address.building": "Корпус / строение",
  "patient.facts.address.unit": "Квартира / помещение",
  "patient.facts.address.postalCode": "Почтовый индекс",
  "patient.facts.address.purpose.unspecified": "Не указано",
  "patient.facts.address.purpose.home": "Фактическое проживание",
  "patient.facts.address.purpose.registration": "Регистрация",
  "patient.facts.address.purpose.temporary": "Временное пребывание",
  "patient.facts.address.purpose.postal": "Почтовый адрес",
  "patient.facts.address.purpose.work": "Рабочий адрес",
  "patient.facts.address.purpose.other": "Другое",
  "patient.facts.address.state.current": "Текущий",
  "patient.facts.address.state.former": "Прежний",
  "patient.facts.address.state.unspecified": "Не указано",

  "patient.identity.countryOption": "{action} {state} ({start}–{end})",
  "patient.identity.sourceChanged": "Файлы изменились после распознавания. Перед сохранением распознайте их заново; черновик сохранён.",
  "patient.identity.addCitizenship": "Добавить гражданство",
  "patient.identity.addResidence": "Добавить страну проживания",
  "patient.identity.addName": "Добавить вариант имени",
  "patient.identity.printedNames": "Имена, указанные в документе",
  "patient.identity.permitCountry": "Страна, выдавшая разрешение на проживание",
  "patient.identity.permitHint": "Разрешение не подтверждает обычное место проживания. Проживание и его период подтверждаются отдельно.",
  "patient.identity.compare": "Сверить с карточкой пациента",
  "patient.identity.selectionHint": "Отметьте только нужные изменения. Сохранение только документа не меняет данные пациента.",
  "patient.identity.same": "Уже записано",
  "patient.identity.countryAction": "Добавить или связать запись страны",
  "patient.identity.newPeriod": "Добавить новый период",
  "patient.identity.add": "Добавить запись",
  "patient.identity.link": "Связать и уточнить существующую запись",
  "patient.identity.nameAction": "Добавить или исправить имя",
  "patient.identity.formerNameEnd": "При действительной смене имени: последний день использования прежнего имени. Для исправления оставьте пустым.",
  "patient.identity.nameAmbiguous": "Проверьте варианты имени и выберите предпочтительное написание перед применением.",
  "patient.identity.resultingName": "Имя, которое будет отображаться",
  "patient.identity.acceptName": "Подтверждаю это отображаемое имя",
  "patient.identity.applyRotation": "Применить поворот по Google",
  "patient.identity.conflict": "Документ или данные пациента изменились. Черновик сохранён в форме; загрузите сохранённый документ или повторите сверку с карточкой.",
  "patient.identity.recompare": "Прочитать текущие данные и сверить заново",
  "patient.identity.recompared": "Текущие данные загружены. Проверьте и отметьте изменения заново.",
  "patient.identity.countryExists": "Для этой страны уже есть продолжающаяся запись. Выберите её для привязки или уточнения.",
  "patient.identity.primaryExists": "Другой полис уже основной. Явно подтвердите его переназначение.",
  "patient.identity.replaceDraft": "Распознать заново и заменить поля черновика?",
  "patient.identity.replaceDraftDetail": "Распознавание заменит введённые поля документа. Данные пациента изменятся только после выбора и применения изменений.",
  "patient.identity.insuranceRole": "Роль полиса",
  "patient.identity.role.primary": "Основной",
  "patient.identity.role.secondary": "Дополнительный",
  "patient.identity.reassignPrimary": "Сделать этот текущий основной полис дополнительным:",
  "patient.identity.insurerPhone": "Телефон страховой",
  "patient.identity.insurerEmail": "Email страховой",
  "patient.identity.assistanceName": "Служба ассистанса",
  "patient.identity.assistancePhone": "Телефон ассистанса",
  "patient.identity.assistanceEmail": "Email ассистанса",
  "patient.identity.errorReason": "Причина отметки об ошибочной записи",
  "patient.identity.requisites": "Реквизиты документа",
  "patient.identity.policyRequisites": "Реквизиты полиса",
  "patient.identity.moreRequisites": "Дополнить",
  "patient.identity.moreRequisitesTitle": "Дата выдачи и кем выдан",
  "patient.identity.documentData": "Данные в документе",
  "patient.identity.furtherCitizenship": "Другое гражданство",
  "patient.identity.permitBrief": "ВНЖ",
  "patient.identity.refine": "Уточнить",
  "patient.identity.countriesTitle": "Гражданство, проживание и ВНЖ",
  "patient.identity.done": "Готово",
  "patient.identity.spellings": "Написаний: {count}",
  "patient.identity.languageUnknown": "Язык не указан",
  "patient.identity.international": "международное",
  "patient.identity.editName": "Изменить имя {name}",
  "patient.identity.nameInDocument": "Имя в документе",
  "patient.identity.sourceDocument": "Исходный документ",
  "patient.identity.sourceFiles": "Файлов: {count}",
  "patient.identity.enlarge": "Увеличить",
  "patient.identity.windowTabs": "Разделы окна документа",
  "patient.identity.tabFields": "Реквизиты и данные",
  "patient.identity.tabChanges": "Изменения в карточке",
  "patient.identity.pickedOf": "{selected}/{total}",
  "patient.identity.currentChart": "Текущая карточка пациента",
  "patient.identity.transferOf": "Как перенести: {name}",
  "patient.identity.documentOnly": "Только документ",
  "patient.identity.saveAndApply": "Сохранить и применить · {count}",
  "patient.identity.pickedCount": "Выбрано изменений: {count}",
  "patient.identity.chartUnchanged": "Карточка пациента останется без изменений",
  "patient.identity.checkBeforeSaving": "Перед сохранением сверьте значения со сканом.",
  "patient.identity.erroneousHolds": "Запись, отмеченная как ошибочная, не меняет карточку. Сохраните только документ.",
  "patient.identity.acceptHolds": "Подтвердите отображаемое имя на вкладке изменений.",
  "patient.facts.country": "Страна",
  "patient.facts.state": "Состояние",
  "patient.facts.state.current": "Текущее",
  "patient.facts.state.former": "Прежнее",
  "patient.facts.state.unspecified": "Не уточнено",
  "patient.facts.details": "Подробности",
  "patient.facts.start": "С какого времени",
  "patient.facts.end": "До какого времени",
  "patient.facts.partialDate": "ГГГГ, ГГГГ-ММ или ГГГГ-ММ-ДД",
  "patient.facts.source": "Источник",
  "patient.facts.source.reported": "Со слов",
  "patient.facts.source.document": "Документ",
  "patient.facts.source.unknown": "Не записано",
  "patient.facts.document": "Документ-основание",
  "patient.facts.note": "Примечание",
  "patient.facts.erroneous": "Внесено ошибочно",
  "patient.facts.citizenships": "Гражданства",
  "patient.facts.residences": "Проживания",
  "patient.facts.contacts": "Контактные данные",
  "patient.facts.removeDraft": "Убрать новую запись",
  "patient.facts.add": "Добавить запись",
  "patient.facts.deliveryInUse": "Перед изменением или удалением контакта отключите связанный канал доставки.",
  "patient.facts.stale": "Данные изменились в другой сессии. Загрузите сохранённые значения для повторного редактирования.",
  "patient.facts.contactType": "Тип контакта",
  "patient.facts.contactType.phone": "Телефон",
  "patient.facts.contactType.email": "Электронная почта",
  "patient.facts.purpose": "Назначение",
  "patient.facts.purpose.unspecified": "Не указано",
  "patient.facts.purpose.personal": "Личный",
  "patient.facts.purpose.work": "Рабочий",
  "patient.facts.purpose.travel": "Для поездок",
  "patient.facts.purpose.other": "Другое",
  "patient.facts.preferred": "Предпочтительный",
  "patient.facts.verifiedContact": "Контакт подтверждён",
  "patient.facts.count": "Записей: {count}",
  "patient.facts.period": "Период",
  "patient.facts.former": "Прежние записи",
  "patient.facts.older": "Предыдущие редакции",
  "patient.facts.hoursNotEnforced": "Часы доставки сохраняются, но пока не ограничивают время отправки сообщений пациенту.",
  "patient.facts.edit.citizenships": "Изменить гражданства",
  "patient.facts.edit.residences": "Изменить проживания",
  "patient.facts.edit.contacts": "Изменить контактные данные",
  "patient.facts.history.citizenships": "История: гражданства",
  "patient.facts.history.residences": "История: проживания",
  "patient.facts.history.contacts": "История: контактные данные",
  "patient.facts.channels": "Мессенджеры",
  "patient.documents.downloadScanNamed": "Скачать скан: {name}",
  "patient.documents.editNamed": "Изменить: {name}",
  "patient.documents.expiredOn": "Срок истёк {date}",
  "patient.sheet.menu": "Титульный лист: вид и действия",
  "patient.sheet.layout": "Вид листа",
  "patient.sheet.layout.dossier": "Досье",
  "patient.sheet.layout.passport": "Паспорт и лента",
  "patient.sheet.chart": "Карта",
  "patient.sheet.actsOf": "{part}: действия",
  "patient.sheet.actIn": "{act}: {part}",
  "patient.sheet.add": "Добавить",
  "patient.sheet.facts": "Главное о пациенте",
  "patient.sheet.fact.age": "Возраст",
  "patient.sheet.fact.citizenship": "Гражданство",
  "patient.sheet.fact.residence": "Живёт в",
  "patient.sheet.fact.consent": "Согласие",
  "patient.sheet.basic": "Основные данные",
  "patient.sheet.keeping": "Ведение карты",
  "patient.sheet.contact": "Контакт",
  "patient.sheet.marks": "Отметки",
  "patient.sheet.edit.basic": "Изменить основные данные",
  "patient.sheet.edit.registration": "Изменить сведения о регистрации",
  "patient.sheet.messengers.manage": "Управление мессенджерами",
  "patient.sheet.consent.preview": "Предпросмотр бланка",
  "patient.sheet.consent.blank": "Скачать бланк",
  "patient.sheet.consent.signed": "Скачать подписанное",
  "patient.sheet.consent.revoke": "Отозвать",
  "patient.documents.noExpiry": "бессрочно",
  "patient.documents.until": "до {date}",
  "patient.documents.hideExpired": "Скрыть истёкшие",
  "patient.documents.showExpiredCount": "Показать истёкшие ({count})",
  "patient.sheet.docs.document": "Документ",
  "patient.sheet.docs.number": "Номер",
  "patient.sheet.docs.country": "Страна",
  "patient.sheet.docs.term": "Срок",
  "patient.sheet.docs.role": "Роль",
  "patient.sheet.docs.kind": "Вид",
  "patient.facts.periodBetween": "{start} – {end}",
  "patient.facts.periodSince": "с {start}",
  "patient.facts.periodUntil": "до {end}",
  "patient.facts.formerly": "ранее:",
  "patient.sheet.channels": "Каналы связи",
  "patient.sheet.channels.channel": "Канал",
  "patient.sheet.channels.address": "Адрес",
  "patient.sheet.channels.messages": "Сообщения клиники",
  "patient.sheet.channels.allowed": "разрешено",
  "patient.sheet.channels.notChosen": "не выбрано",
  "patient.sheet.channels.blocked": "заблокировано",
  "patient.sheet.channels.noMessages": "Типы сообщений не выбраны",
  "patient.sheet.channels.links": "Мессенджеры",
  "patient.sheet.channels.settings": "Настройки связи",
  "patient.sheet.consentAccepted": "Согласие принято",
  "patient.sheet.consentMissing": "Согласия нет",
};
